import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('circles', 'inviteToFamilyCircle');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'post',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },

    'family_members',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/circles/inviteToFamilyCircle.js